module.exports = "/_next/static/images/4_5-66e640ad.gif";